{
  "$id": "module://tax-setup",
  "$schema": "wealthlane://schemas/domain",
  "title": "Tax Setup",
  "description": "Tax item create/update DTO field catalog",
  "type": "object",
  "$defs": {
    "taxSelectId": {
      "type": "string",
      "format": "uuid",
      "widget": "select"
    }
  },
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "statusSystemName": {
      "type": "string",
      "title": "Status",
      "widget": "hidden"
    },
    "name": {
      "type": "string",
      "title": "Name",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100
    },
    "taxPeriodId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "Tax Period"
    },
    "jurisdictionLevelId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "Jurisdiction Level"
    },
    "taxCode": {
      "type": "string",
      "title": "Pay Code",
      "widget": "text",
      "noBlank": true,
      "charset": "alphaNumWithBasicSymbols"
    },
    "parentTaxItemId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "Parent Tax"
    },
    "comment": {
      "type": "string",
      "title": "Comment",
      "widget": "textarea",
      "adapterProps": { "rows": 3 }
    },
    "countryId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "Country"
    },
    "stateId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "State"
    },
    "stateText": {
      "type": "string",
      "title": "State",
      "widget": "text"
    },
    "cityId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "City"
    },
    "cityText": {
      "type": "string",
      "title": "City",
      "widget": "text"
    },
    "incomeYtdTypeId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "Income Ytd Type"
    },
    "equityCompensationLevelId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "Applicable To"
    },
    "equityCompensationLevelName": {
      "type": "string",
      "title": "Applicable To Name",
      "widget": "hidden"
    },
    "participantId": {
      "$ref": "module://participant#/$defs/participantId",
      "title": "Participant Name"
    },
    "planId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "Plan"
    },
    "grantId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "Grant"
    },
    "awardId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "Award Number"
    },
    "transactionId": {
      "$ref": "#/$defs/taxSelectId",
      "title": "Vesting Tranche"
    },
    "userDefinedCriteria": {
      "type": "object",
      "title": "User Defined Criteria",
      "widget": "rule-builder",
      "adapterProps": {
        "configModule": "module://shared/rule-builder/configs/tax-udc"
      }
    },
    "jurisdictionRequiresCountry": {
      "type": "boolean",
      "title": "Requires Country",
      "widget": "hidden",
      "default": false
    },
    "jurisdictionRequiresState": {
      "type": "boolean",
      "title": "Requires State",
      "widget": "hidden",
      "default": false
    },
    "jurisdictionRequiresCity": {
      "type": "boolean",
      "title": "Requires City",
      "widget": "hidden",
      "default": false
    },
    "jurisdictionAllowUdc": {
      "type": "boolean",
      "title": "Allow UDC",
      "widget": "hidden",
      "default": false
    },
    "jurisdictionEstablishedCountry": {
      "type": "string",
      "title": "Established Country",
      "widget": "hidden"
    },
    "jurisdictionDescription": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "adapterProps": { "rows": 4, "readOnly": true }
    },
    "jurisdictionUseStateText": {
      "type": "boolean",
      "title": "Use State Text",
      "widget": "hidden",
      "default": false
    },
    "jurisdictionUseCityText": {
      "type": "boolean",
      "title": "Use City Text",
      "widget": "hidden",
      "default": false
    },
    "applicableSystemName": {
      "type": "string",
      "title": "Applicable System Name",
      "widget": "hidden"
    },
    "taxBrackets": {
      "type": "array",
      "title": "Tax Brackets",
      "minItems": 1,
      "autoSeed": 1,
      "items": {
        "type": "object",
        "properties": {
          "taxRate": {
            "type": "string",
            "title": "Tax Rate (%)",
            "widget": "text"
          },
          "lowerLimit": {
            "type": "string",
            "title": "Lower Limit",
            "widget": "text",
            "patternPreset": "DIGITS_WITH_COMMA"
          },
          "upperLimit": {
            "type": "string",
            "title": "Upper Limit",
            "widget": "text",
            "patternPreset": "DIGITS_WITH_COMMA"
          }
        }
      }
    }
  }
}
